/**
 * Coure SMS Delivery Service
 * Coure SMS Delivery service Api 
 *
 * OpenAPI spec version: v1.0
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Currency } from './currency';
import { WalletRequestDto } from './walletRequestDto';


export interface WalletResponseDto extends WalletRequestDto { 
    rate: number;
    balance: number;
    currency: Currency;
    isOkResponse: boolean;
    totalCost: number;
}
